export default "__VITE_ASSET__C1p69L3I__"